import { IFormBuilderItemBase, IFormBuilderItemDataBase, TFormBuilderItem } from "./formBuilderItem";

type TFormBuilderButtonType = "button";
export type TFormBuilderButtonRole = "submit" | "reset";

export interface IFormBuilderButtonSettings {
  label: string;
}

export interface IFormBuilderButtonData extends IFormBuilderItemDataBase {
  type: TFormBuilderButtonType;
  role: TFormBuilderButtonRole;
  settings: IFormBuilderButtonSettings;
}

export interface IFormBuilderButton extends IFormBuilderItemBase {
  data: IFormBuilderButtonData;
}

export type TFormBuilderButtonSettings = IFormBuilderButton["data"]["settings"];

export function isFormBuilderButtonItem(item: TFormBuilderItem): item is IFormBuilderButton {
  return item.data.type === "button";
}

export function isFormBuilderButtonType(value: string): value is TFormBuilderButtonType {
  return value === "button";
}

export function isFormBuilderButtonRole(value: string): value is TFormBuilderButtonRole {
  return value === "submit" || value === "reset";
}

export function formBuilderGenerateDefaultResetButton(): IFormBuilderButton {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "button",
      role: "reset",
      settings: {
        label: "Reset", // TODO: Translation
      },
    },
  };
}

export function formBuilderGenerateDefaultSubmitButton(): IFormBuilderButton {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "button",
      role: "submit",
      settings: {
        label: "Submit", // TODO: Translation
      },
    },
  };
}